export const tag = () => (
  <path
    d="M7 7h.01m13.58 6.41l-7.17 7.17a1.998 1.998 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
